import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { DropdownButton, MenuItem } from 'react-bootstrap/lib';
import { splitWorkLocation } from '../lib/formatters';

export default class SurveyLocationSelect extends Component {
  static propTypes = {
    row: PropTypes.object,
    actions: PropTypes.func,
    jobId: PropTypes.number,
    dropdownOnJobMatchCard: PropTypes.bool,
    disabled: PropTypes.bool
  };

  static defaultPropTypes = {
    disabled: false
  };

  handleSelect(location, idx) {
    this.props.actions('surveyPriceLocation', {
      surveyPriceLocation: location,
      org_job_id: this.props.jobId
    });
  }

  render() {
    const { row, dropdownOnJobMatchCard, disabled } = this.props;

    if (!row) {
      return null;
    }

    const greenCheck = <i className="icon-check" aria-hidden="true" />;
    let surveyPriceLocationDisplay = row.payscale_job_info.surveyPriceLocation
      ? row.payscale_job_info.surveyPriceLocation
      : row.payscale_job_info.workLocation;

    if (surveyPriceLocationDisplay == row.payscale_job_info.workLocationExact) {
      surveyPriceLocationDisplay = row.payscale_job_info.workLocation;
    }

    let selectedSurveyPriceLocation = row.payscale_job_info.workLocationExact;
    if (row.payscale_job_info.surveyPriceLocation) {
      selectedSurveyPriceLocation = row.payscale_job_info.surveyPriceLocation;
    }

    const nationalLocation = splitWorkLocation(row.payscale_job_info.workLocationExact).country;
    if (nationalLocation == row.payscale_job_info.workLocationExact) {
      return <div className="survey__dropdowns">{nationalLocation}</div>;
    }

    let menuKey = surveyPriceLocationDisplay;
    if (menuKey.length >= 20) {
      menuKey = menuKey.slice(0, 16) + '...';
    }

    return (
      <div className="survey__dropdowns">
        {dropdownOnJobMatchCard ? <span className="dropdown__btn--label">Location: </span> : null}
        <DropdownButton
          title={menuKey}
          id="survey-location-select-dropdown"
          className={
            dropdownOnJobMatchCard ? 'survey-location__dropdown--btn survey-location__popover--btn' : 'dropdown__btn'
          }
          disabled={disabled}
        >
          <MenuItem
            key={row.payscale_job_info.workLocationExact}
            onSelect={this.handleSelect.bind(this, row.payscale_job_info.workLocationExact)}
          >
            {selectedSurveyPriceLocation === row.payscale_job_info.workLocationExact ? greenCheck : ''}
            {row.payscale_job_info.workLocation}
          </MenuItem>
          <MenuItem key={nationalLocation} onSelect={this.handleSelect.bind(this, nationalLocation)}>
            {selectedSurveyPriceLocation === nationalLocation ? greenCheck : ''}
            {nationalLocation}
          </MenuItem>
        </DropdownButton>
      </div>
    );
  }
}
